import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";

/**
 * Fetches all categories from the backend.
 *
 * @returns {Promise<Object>}
 */
const fetchCategories = async () => {
  return apiCall(AUTH_ROUTES.CATEGORIES_API_ENDPOINT, {
    method: "GET",
  });
};

export default fetchCategories;
